<template>
	<c-dialog ref="dialog" height="300" width="600" @resolve="editHandle">
		<c-form ref="form" unit-width="100%">
      <c-input type="hidden" name="id"></c-input>
      <c-form-item label="属性" required tip="请选择属性">
        <c-select name="parent_id" v-model="parentId" async @search="searchAttribute" :value-data="selectedAttribute"></c-select>
      </c-form-item>
      <c-form-item label="属性值" required tip="归属相同属性的属性值不允许重名">
        <c-input name="attribute_value"></c-input>
      </c-form-item>
			<c-form-item label="备注">
        <c-input type="textarea" name="remark"></c-input>
			</c-form-item>
    </c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {
	computed: {
	},
	
	data() {
		return {
			  editState: false,
        parentId:0,        //已选中的属性ID
        selectedAttribute:[], //已选中的属性
    }
	},

	methods: {
    /*******搜索属性*****************/
    searchAttribute(keyword, resolve){
      this.request({
        url:'/spu/attribute/options',
        data: {
          attribute_type:4,   //仅展示【选项类型】属性
          keyword: keyword
        },
        success:data => {
          resolve(data);
        }
      })
    },

		/*********打开编辑框，初始化**********/
		open(data) {
			this.$refs.form.clear();
			if (data) {
        //已选中的[属性]
        this.selectedAttribute = [{
          name: data.attribute_name,
          value:data.parent_id
        }];
        //已选中的[属性]Id
        this.parentId = data.parent_id;
				this.$refs.form.set(data);
			}
			//填充form表单
			this.$refs.dialog.open({
				  title:'编辑属性值'
			});
		},

		/*******添加、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: '/spu/attribute/value/edit',
				rule: {
          parent_id: '请选择需要添加值的属性',
          attribute_value: '请选输入属性值信息',
        },
				dataFormatter: data => {
					return data;
				},
				success: (data, res) => {
					next();
                    this.$message({
                        message: '编辑成功',  // 提示内容,
                        type: 'success'
                    });
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>